const NavigationTabs = Object.freeze({
    SYSTEMS: 'SYSTEMS',
    GENERAL: 'GENERAL',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    EMAILS: 'EMAILS',
    LOGOUT: 'LOGOUT',
    STUDIES: 'STUDIES',
    RECENT_ACTIVITY: 'RECENT_ACTIVITY',
});

export default NavigationTabs;
